import { Link } from 'react-router-dom'
import { Gamepad2, Settings2, X } from 'lucide-react'
import type { GameLessonPathGame } from '@/api/games'

interface Props {
  open: boolean
  onClose: () => void
  games: GameLessonPathGame[]
}

export function GamesPreviewModal({ open, onClose, games }: Props) {
  if (!open) return null

  const publishedCount = games.filter((game) => game.published).length

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-label="선택한 레슨 경로의 게임"
        className="flex max-h-[80vh] w-full max-w-xl flex-col overflow-hidden rounded-xl bg-white shadow-xl"
      >
        <header className="flex items-start justify-between border-b border-slate-200 px-5 py-4">
          <div>
            <div className="mb-1 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-orange-600">
              <Gamepad2 className="size-3.5" />
              Exact lesson path
            </div>
            <h2 className="text-base font-semibold text-slate-900">게임 연결 상태</h2>
            <p className="mt-1 text-xs text-slate-500">
              총 {games.length}개 · 공개 {publishedCount}개 · Draft {games.length - publishedCount}개
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-100"
            aria-label="닫기"
          >
            <X className="size-5" />
          </button>
        </header>

        <div className="flex-1 overflow-y-auto p-5">
          {games.length === 0 ? (
            <div className="py-10 text-center">
              <Gamepad2 className="mx-auto size-8 text-slate-300" />
              <p className="mt-3 text-sm font-medium text-slate-500">
                이 경로에 연결된 게임이 없습니다.
              </p>
            </div>
          ) : (
            <ul className="space-y-2">
              {games.map((game) => (
                <li
                  key={game.gameKey}
                  className="flex items-center justify-between rounded-lg border border-slate-200 bg-slate-50/60 px-3 py-2.5"
                >
                  <code className="text-xs font-semibold text-slate-700">
                    {game.gameKey}
                  </code>
                  <span
                    className={game.published
                      ? 'rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-semibold text-emerald-700'
                      : 'rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-700'}
                  >
                    {game.published ? 'Published' : 'Draft'}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <footer className="flex items-center justify-between border-t border-slate-200 bg-slate-50 px-5 py-3">
          <p className="text-xs text-slate-500">
            연결 수정은 게임 관리에서만 할 수 있습니다.
          </p>
          <Link
            to="/contents/games"
            className="inline-flex items-center gap-1.5 rounded-lg bg-orange-600 px-3 py-2 text-xs font-semibold text-white hover:bg-orange-700"
          >
            <Settings2 className="size-3.5" />
            게임 연결 관리
          </Link>
        </footer>
      </div>
    </div>
  )
}
